import {AdminSortField} from 'src/openapi/admin/models/AdminSortField';

export const SELECTION_KEY = 'admin-role-assigned-users';

export const COLUMNS = {
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    JOB_TITLE: 'jobTitle',
    STATUS: 'statusCode',
};

export const SORT_FIELDS = {
    [COLUMNS.EMAIL]: AdminSortField.EMAIL,
    [COLUMNS.FIRST_NAME]: AdminSortField.FIRST_NAME,
    [COLUMNS.LAST_NAME]: AdminSortField.LAST_NAME,
    [COLUMNS.JOB_TITLE]: AdminSortField.JOB_TITLE,
    [COLUMNS.STATUS]: AdminSortField.STATUS,
};

export const HEADERS = {
    [COLUMNS.EMAIL]: 'Email',
    [COLUMNS.FIRST_NAME]: 'First Name',
    [COLUMNS.LAST_NAME]: 'Last Name',
    [COLUMNS.JOB_TITLE]: 'Job Title',
    [COLUMNS.STATUS]: 'Status',
};

const DEFAULT_WIDTH = {
    defaultWidth: 200,
    minWidth: 180,
    maxWidth: 250,
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.EMAIL,
        fixed: true,
        defaultWidth: 500,
        minWidth: 400,
        maxWidth: 600,
    },
    {columnId: COLUMNS.FIRST_NAME, fixed: false, ...DEFAULT_WIDTH},
    {columnId: COLUMNS.LAST_NAME, fixed: false, ...DEFAULT_WIDTH},
    {columnId: COLUMNS.JOB_TITLE, fixed: false, ...DEFAULT_WIDTH},
    {columnId: COLUMNS.STATUS, fixed: false, ...DEFAULT_WIDTH},
];
